import { TabUnderline } from "@/design-system/Tabs/CategoryTab";
import { cn } from "@/lib/utils";
import { canUseClubImportSelector } from "@/redux/user/userSlice";
import { useTranslation } from "@repo/shared/i18n";
import { useSelector } from "react-redux";
import { NavLink } from "react-router";

type ActiveTab = "overview" | "players" | "builder" | "my-evolutions";

interface EvolutionsMobileNavProps {
  active: ActiveTab;
}

export const EvolutionsMobileNav = ({ active }: EvolutionsMobileNavProps) => {
  const { t } = useTranslation("evolutions");
  const items: { label: string; tab: ActiveTab; to: string }[] = [
    {
      label: t("mobileNav.overview"),
      tab: "overview",
      to: "/evolutions",
    },
    {
      label: t("mobileNav.players"),
      tab: "players",
      to: "/evolutions/players",
    },
    {
      label: t("mobileNav.builder"),
      tab: "builder",
      to: "/evolutions/builder",
    },
    {
      label: t("mobileNav.myEvos"),
      tab: "my-evolutions",
      to: "/evolutions/my-evolutions",
    },
  ];

  // The SBC category tabs' look: faint words, the active one white over a
  // primary underline. Scrolls sideways when long labels don't fit.
  return (
    <nav className="no-scrollbar mb-3 w-full overflow-x-auto bg-background mobile:hidden">
      <div className="flex w-max min-w-full justify-around border-b border-edge-strong px-2">
        {items.map(({ label, tab, to }) => {
          const isActive = active === tab;
          return (
            <NavLink
              key={tab}
              to={to}
              className={cn(
                "relative px-2 py-3 text-sm font-medium whitespace-nowrap transition-colors",
                isActive
                  ? "text-foreground"
                  : "text-foreground-faint hover:text-foreground-body",
              )}
            >
              {label}
              {isActive && <TabUnderline className="-bottom-px" />}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
